import axios from 'axios';

const apiCobranca = axios.create({
  baseURL: process.env.REACT_APP_COBRANCA_URL,
});

export default apiCobranca;
